import React from 'react';
import './chat-messages-list.scss';

interface PendingChatMessageProps {
  messageText: string;
}

const PendingChatMessage = ({ messageText }: PendingChatMessageProps) => (
  <div className="pending-chat-message">
    <div className="message-content">
      <div className="message-text">{messageText}</div>
      <div className="sending-indicator" aria-label="Sending message">
        <span className="dot" />
        <span className="dot" />
        <span className="dot" />
      </div>
    </div>
  </div>
);

export default PendingChatMessage;
